<template>
  <Modal title="变更服务代理人" v-model="visible" width="400" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <div class="table-box tableBox">
      <Form :model="formData" ref="formValidate" class="modal-form" label-position="left">
        <FormItem label="原服务代理人" prop="serviceAgent">
          <span>{{ formData.serviceAgentStaffNo  || '-'}}/{{ formData.serviceAgentName  || '-'}}</span>
        </FormItem>
        <FormItem label="新服务代理人" prop="serviceAgent" :rules="$units.formRule.required('请选择')">
          <Select v-model="formData.serviceAgent" transfer clearable filterable placeholder="请选择">
            <Option v-for="(item, i) in orgUserList" :key="i" :value="item.id"
              :label="item.staffNo ? item.staffNo + '/' + item.name : item.name">
              <i class="dian" :class="{'red': item.workingState == 0 ,'orange':item.isSus == 1 }"></i>
              {{ item.staffNo ? item.staffNo + '/' + item.name : item.name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem prop="effectiveDate" label="生效日期"
          :rules="$units.formRule.required('请选择生效日期', trigger = 'change', type = 'date')">
          <DatePicker transfer type="date" v-model="formData.effectiveDate" format="yyyy-MM-dd" placeholder="请选择">
          </DatePicker>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save">确认</Button>
      </div>
    </div>
  </Modal>
</template>
<script>
import dayjs from 'dayjs';
export default {
  props: {},
  data() {
    return {
      visible: false,
      isAbnormal:false,
      orgUserList: [],
      formData: {
        serviceAgent: '',//服务代理人
        effectiveDate: '',//服务生效日期
      }
    };
  },

  methods: {
    save() {
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          this.$http({
            url: this.isAbnormal?'/buz/policyAbnormal/updateServiceAgent':'/buz/policy/updateServiceAgent',
            type: 'POST',
            data: {
              policyNo: this.formData.policyNo,
              serviceAgent: this.formData.serviceAgent,
              serviceEffectiveDate: dayjs(this.formData.effectiveDate).format('YYYY-MM-DD'),
            }
          }).then((res) => {
            this.$emit('success')
            this.visible = false;
          })
        }
      })
    },
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      console.log('data-------------',data)
      this.visible = true;
      this.isAbnormal = data.isAbnormal;
      this.$refs.formValidate && this.$refs.formValidate.resetFields();

      this.$http({
        url: '/buz/userBase/queryUserByEntryConfig',
        type: 'get',
        data: {
          orgId: data.orgId,
          // workingState:'1',
          // isSus:'0'
        },
      }).then((res) => {
        this.orgUserList = res.data;
      })
      if(data.serviceAgent)delete data.serviceAgent
      this.formData = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35BF3F;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #E3461F;
  }
}

/deep/.ivu-form-item-content {
  display: flex;
}

/deep/.ivu-date-picker {
  width: 100%;
}
</style>
